import { Collapse, Flex } from '@chakra-ui/react';
import { forwardRef } from 'react';

import Label from './label.component';

const LabelsContainer = forwardRef(({ labels, isExpanded }, ref) => {
  if (!labels || labels.length === 0) {
    return null;
  }

  return (
    <Collapse
      in={isExpanded}
      startingHeight={24}
      data-testid='collapse-component'
    >
      <Flex
        data-testid='labels-container'
        w='full'
        ref={ref}
        align='center'
        gap={2}
        flexWrap='wrap'
      >
        {labels?.map((label) => (
          <Label
            key={label?.id}
            label={label}
            match={label?.match}
          />
        ))}
      </Flex>
    </Collapse>
  );
});

export default LabelsContainer;
